import styled from 'styled-components';
import { device } from '../../styles/devices';
import { COLORS } from '../../styles/variables';

interface StyleProps {
  width?: string;
  eDeposit?: boolean;
}

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.8);
  padding: 0;
  z-index: 1000;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media ${device.tablet} {
    padding: 30px 20px;
  }
`;

export const ModalContainer = styled.div<StyleProps>`
  position: relative;
  width: ${({ width, eDeposit }) => (eDeposit ? '600px' : width || '100%')};
  max-width: 100%;
  margin: 0 auto;
  display: flex;
  padding: ${({ eDeposit }) => (eDeposit ? '0px' : '80px 30px')};
  flex-direction: column;
  height: 100vh;
  background-color: ${COLORS.white};
  border: 1px solid ${COLORS.white};
  overflow-y: auto;
  text-align: left;
  @media ${device.tablet} {
    height: auto;
    padding: ${({ eDeposit }) => (eDeposit ? '0px' : '24px 80px')};
    max-width: 1450px;
  }
`;

export const CloseModalButton = styled.button<StyleProps>`
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  background: transparent;
  position: absolute;
  top: ${({ eDeposit }) => (eDeposit ? '18px' : '30px')};
  right: ${({ eDeposit }) => (eDeposit ? '18px' : '30px')};
  @media ${device.tablet} {
    top: ${({ eDeposit }) => (eDeposit ? '18px' : '39px')};
    right: ${({ eDeposit }) => (eDeposit ? '18px' : '49px')};
  }
`;
